import React, { useEffect, useState } from 'react';
import { Card } from 'antd';
import ReturnForm from '../../components/Return/ReturnForm';
import { useReturn } from '../../store/returnContext';
import { useParams, useNavigate } from 'react-router-dom';
import { t } from 'i18next';

const ReturnFormPage: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const { returns, fetchReturns } = useReturn();
    const [editReturn, setEditReturn] = useState<any | undefined>(undefined);
    const navigate = useNavigate();

    useEffect(() => {
        fetchReturns();
    }, []);

    useEffect(() => {
        if (id) {
            const ret = returns.find(r => r.id === id || r.id === id);
            setEditReturn(ret);
        } else {
            setEditReturn(undefined);
        }
    }, [id, returns]);

    return (
        <div style={{ padding: 16 }}>
            <Card title={editReturn ? t("edit_return") : t("add_return")} variant="outlined">
                <ReturnForm
                    editReturn={editReturn}
                    onFinishEdit={() => navigate('/returns/list')}
                />
            </Card>
        </div>
    );
};

export default ReturnFormPage;
